export default "__VITE_ASSET__57c1d964__"